import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpload = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M910.222 568.89v284.444c0 31.288-25.6 56.89-56.89 56.89h-682.668c-31.288 0-56.89-25.6-56.89-56.89v-284.444c0-31.288-25.6-56.89-56.89-56.89s-56.89 25.6-56.89 56.89v341.334c0 62.578 51.2 113.778 113.778 113.778h796.444c62.578 0 113.778-51.2 113.778-113.778v-341.334c0-31.288-25.6-56.89-56.89-56.89s-56.89 25.6-56.89 56.89zM568.89 210l106.952 106.952c22.188 22.188 58.028 22.188 80.212 0s22.188-58.026 0-80.212l-204.23-204.23c-22.188-22.188-58.026-22.188-80.212 0l-204.23 204.23c-22.188 22.188-22.188 58.026 0 80.212s58.026 22.188 80.212 0l107.52-106.952v423.226c0 31.29 25.6 56.89 56.89 56.89s56.89-25.6 56.89-56.89v-423.226z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgUpload);
export default ForwardRef;
